import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRules } from '../../../higher_order_components/with_rules';
import { Input } from '../input/input';
import { Label } from '../label/label';
import { SimpleFlexbox } from '../../flexbox/flexbox';

class _InputGroup extends Component {

    /**
     * renders the InputGroup component
     * @returns {Node} the InputGroup component
     */
    render = () => {
        const { props } = this;
        const { identifier, className, label, ...restProps } = props;
        return (
            <SimpleFlexbox display="flex" column className={className}>
                <Label identifier={identifier}>{label}</Label>
                <Input identifier={identifier} {...restProps} />
            </SimpleFlexbox>
        );
    };

}

_InputGroup.propTypes = {
    identifier: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string
};

const InputGroup = withRules(_InputGroup);

export { InputGroup, _InputGroup };
